import { useDispatch, useSelector } from 'react-redux'
import page_img from '../../components/Navigation/icons/verifica.svg'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { Stepper, Step } from 'react-form-stepper';

import add_img from '../../assets/images/add.svg'
import question_img from '../../assets/images/demo/question.svg'
import arrow_img from '../../assets/images/arrow-right.svg'

import { toast } from 'react-toastify';

import './Exams.css'
import ExamInfo from './_components/ExamInfo';
import ExamPermissions from './_components/ExamPermissions';
import { fetchAddQuestionsModules, fetchCreateExam, fetchEditExam, fetchExam } from './ExamApi';
import { setLoading } from '../../services/global/globalSlice';
import ExamQuestion from './_components/ExamQuestion';
import { prepareModules } from '../../utils/questions';
import ExamSettings from './_components/ExamSettings';
import ExamModules from './_components/ExamModules';
import ConfirmModal from '../../components/_modals/ConfirmModal';

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding, updateUserOnboarding } from "../../features/User/userSlice"
import { examsTourSteps } from "../../config/tour"
import { selectTenantSettings } from '../../services/utils/appInfoSlice';
import ExamProctoring from './_components/ExamProctoring';

export default function ExamDetailScreen(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const tenantSetting = useSelector(selectTenantSettings)

    const [activeStep, setActiveStep] = useState(0)
    const [examData, setExamData] = useState({})
    const [isUpdated, setIsUpdated] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const {exam_id} = useParams()
    const duplicateFrom = useLocation().state?.duplicateFrom

    const prepareExamData = () => {
        const _data = structuredClone(examData)
        if(_data['start_date'])
            _data['start_date'] = `${new Date(_data['start_date']).toISOString().substring(0,19)}+00:00`
        if(_data['end_date'])
            _data['end_date'] = `${new Date(_data['end_date']).toISOString().substring(0,19)}+00:00`
        else if(_data['end_date'] === "")
            delete _data.end_date
        if(_data['allowed_groups']?.length > 0)
            _data['allowed_groups'] = _data['allowed_groups']?.map(g=>g.group_id)
        if(_data['allowed_users']?.length > 0)
            _data['allowed_users'] = _data['allowed_users']?.map(u=>u.user_id)
        if(_data['time']){
            _data['time'] = parseInt(_data['time'])
        } else if (_data?.time === "" || _data?.time == "null" || _data?.time == null)
            delete _data.time
        if(_data['thresholds']?.length > 0)
            _data['thresholds'] = _data['thresholds']?.map((t)=>{
                if(t.threshold_name){
                    const base = {
                        threshold_name: t.threshold_name,
                        is_showable: !!t.is_showable,
                        score: parseFloat(t.score),
                        threshold_type: t.threshold_type
                    }
                    switch(t.threshold_type){
                        case 'certificate_generation':
                            return {
                                ...base,
                                ...(t.pdf_certificate_template_url && { pdf_certificate_template_url: t.pdf_certificate_template_url }),
                                show_scores: t.show_scores !== false,
                                show_title: t.show_title !== false
                            }
                        case 'esse3_passing_score_threshold':
                            return {
                                ...base,
                                ad_cod: t.ad_cod || ''
                            }
                        case 'esse3_add_to_libretto_threshold':
                            return {
                                ...base,
                                ad_cod: t.ad_cod || '',
                                ad_des: t.ad_des || '',
                                cds_id: t.cds_id !== undefined && t.cds_id !== '' ? parseInt(t.cds_id) : undefined,
                                cds_cod: t.cds_cod || '',
                                pds_id: t.pds_id !== undefined && t.pds_id !== '' ? parseInt(t.pds_id) : undefined,
                                pds_cod: t.pds_cod || '',
                                add_when_passed: !!t.add_when_passed
                            }
                        case 'subject_passing_score_threshold':
                            return {
                                ...base,
                                subject_id: t.subject_id || ''
                            }
                        case 'add_to_group_threshold':
                            return {
                                ...base,
                                group_id: t.group_id || ''
                            }
                        default:
                            return base
                    }
                }
        })
        if(_data['proctoring_setting']){
            const p = _data['proctoring_setting']
            _data['proctoring_setting'] = {
                authorizationType: p.authorizationType || '',
                screenRecording: !!p.screenRecording,
                videoRecording: !!p.videoRecording,
                proctoringType: p.proctoringType || 'Lite',
                pauseResumeTest: !!p.pauseResumeTest,
                endTest: !!p.endTest,
                SecondaryCamera: !!p.SecondaryCamera,
                sessionExpiryTime: Math.min(1800, Math.max(0, parseInt(p.sessionExpiryTime || 1800)))
            }
        }
        if(_data['additional_results_step']?.length > 0)
            _data['additional_results_step'] = _data['additional_results_step']?.map((t)=>{
                if(t.text)
                    return {
                        text: t.text,
                        icon_url: t.icon_url,
                        ...((t?.cta?.title && t?.cta?.url) && {
                            cta: {
                                title: t.cta.title,
                                url: t.cta.url
                            }
                        })
                    }
        })
        return _data
    }

    const renderButton = () => {
        switch(activeStep){
            case 0:
                return t.exam.users
            break;
            case 1:
                return t.exam.questions
            break;
            case 2: 
                return t.exam.structure
            break;
            case 3:
                if(examData.modules?.length === 1)
                    return t.exam.save_and_pubblish
                else
                    return t.exam.modules
            break;
            case 4:
                return t.exam.save_and_pubblish
            break;
            case 5:
                return t.exam.save_and_pubblish
            break;
            default:
                return t.exam.proceed
        }
    }

    const handleExamDataChange = (data) => {
        setExamData(data)
        setIsUpdated(true)
    }

    const getModuleQuestionsLength = (_module) => {
        let count = 0
        _module?.questions?.forEach((q,index)=>{
            if(q.question_type !== 'block')
                count++
            else
                count = count + q.blocks?.length
        })
        return count
    }

    const isModuleValid = (_module) => {
        if(_module?.topics !== undefined){
            return _module.topics.length > 0
                && _module.topics.every(group => group.topic_ids?.length > 0 && parseInt(group.num_questions) >= 1)
        }
        const questionsLength = getModuleQuestionsLength(_module)
        // se non specificato, il backend usa tutte le domande caricate senza estrarne un sottoinsieme
        if(!_module?.num_questions_per_module)
            return questionsLength > 0
        return questionsLength >= _module.num_questions_per_module
    }

    const handleCreateDraft = async () => {
        dispatch(setLoading(true))
        const _examData = prepareExamData()
        const response = await fetchCreateExam(_examData)
        if(response.success){
            setExamData({
                ...examData,
                exam_id: response.data.exam_id
            })
            toast.success(t.exam.settings_saved)
            dispatch(setLoading(false))
            return 'ok'
        } else {
            toast.error(t.exam.error_saving_exam)
            dispatch(setLoading(false))
        }
    }

    const handleEditDetails = async () => {
        const _examData = prepareExamData()
        const response = await fetchEditExam(examData?.exam_id, _examData)
        if(response.success){
            toast.success(t.exam.settings_saved)
            dispatch(setLoading(false))
            return 'ok'
        } else {
            toast.error(t.exam.error_saving_exam)
            dispatch(setLoading(false))
        }
    }

    const handleSaveDraft = async () => {
        if(examData?.exam_id){
            const _examData = prepareExamData()
            _examData['state'] = 'draft'
            const response = await fetchEditExam(examData?.exam_id, _examData)
            if(response.success){
                if(examData?.modules && examData?.modules?.length > 0){
                    if(examData?.modules?.find(m => !isModuleValid(m))){
                        toast.error(t.exam.invalid_question_number)
                        dispatch(setLoading(false))
                        return;
                    }
                    const _modulesData = prepareModules(examData?.modules)
                    const m_response = await fetchAddQuestionsModules(examData?.exam_id, _modulesData)
                    if(m_response.success){
                        toast.success(t.exam.draft_saved)
                        dispatch(setLoading(false))
                        loadExamData()
                    } else {
                        toast.error(t.exam.error_saving_questions)
                        dispatch(setLoading(false))
                    }
                } else {
                    toast.success(t.exam.draft_saved)
                    dispatch(setLoading(false))
                }
                
            } else {
                toast.error(t.exam.error_saving_exam)
                dispatch(setLoading(false))
            }
        } else 
            handleCreateDraft()
    }

    const handleSuspendExam = async () => {
        if(!examData?.exam_id) return
        dispatch(setLoading(true))
        const _examData = prepareExamData()
        _examData['state'] = 'draft'
        const response = await fetchEditExam(examData?.exam_id, _examData)
        if(!response.success){
            toast.error(t.exam.error_saving_exam)
            dispatch(setLoading(false))
            return
        }
        if(examData?.modules?.length > 0 && !examData?.modules?.find(m => !isModuleValid(m))){
            const _modulesData = prepareModules(examData?.modules)
            const m_response = await fetchAddQuestionsModules(examData?.exam_id, _modulesData)
            if(!m_response.success){
                toast.error(t.exam.error_saving_questions)
                dispatch(setLoading(false))
                return
            }
        }
        const newExamData = {
            ...examData,
            state: 'draft'
        }
        setExamData(newExamData)
        toast.success(t.exam.exam_suspended)
        dispatch(setLoading(false))
        return newExamData
    }

    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const handlePubblishExam = async (_,force = false) => {
        if(!force){
            setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.publish_title,
                text: t.exam.publish_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handlePubblishExam(true,true),
                confirmCta: t.exam.publish_cta,
                closeCta: t.modals.no_exit,
            })
        } else {
            if(examData.state !== 'ready'){
                if(examData?.modules && examData?.modules?.length > 0){
                    if(examData?.modules?.find(m => !isModuleValid(m))){
                        toast.error(t.exam.invalid_question_number)
                        dispatch(setLoading(false))
                        return;
                    }
                    const _modulesData = prepareModules(examData?.modules)
                    const m_response = await fetchAddQuestionsModules(examData?.exam_id, _modulesData)
                    if(m_response.success){
                        const _examData = prepareExamData()
                        _examData['state'] = 'ready'
                        _examData['start_date'] = _examData['start_date'] ? _examData['start_date'] : `${new Date().toISOString().substring(0,19)}+00:00`
                        const response = await fetchEditExam(examData?.exam_id, _examData)
                        if(response.success){
                            toast.success(t.exam.exam_ready)
                            dispatch(setLoading(false))
                            navigate('/exams', {replace:true})
                        } else {
                            toast.error(t.exam.error_saving_exam)
                            dispatch(setLoading(false))
                        }
                    } else {
                        toast.error(t.exam.error_saving_questions)
                        dispatch(setLoading(false))
                    }
                } else {
                    toast.error(t.question.missing_questions)
                }
            } else {
                const _examData = prepareExamData()
                _examData['state'] = 'ready'
                _examData['start_date'] = _examData['start_date'] ? _examData['start_date'] : `${new Date().toISOString().substring(0,19)}+00:00`
                const response = await fetchEditExam(examData?.exam_id, _examData)
                if(response.success){
                    toast.success(t.exam.exam_ready)
                    dispatch(setLoading(false))
                    navigate('/exams', {replace:true})
                } else {
                    toast.error(t.exam.error_saving_exam)
                    dispatch(setLoading(false))
                }
            }
            
        }
    }

    const handleNextStep = () => {
        switch(activeStep){
            case 0:
                if(examData.title && examData.description){
                    setActiveStep(1)
                } else {
                    toast.error(t.exam.missing_title_description)
                }
            break;
            case 1:
                if(!examData?.exam_id){
                    dispatch(setLoading(true))
                    handleCreateDraft().then(()=>{
                        setActiveStep(2)
                    })
                } else {
                    handleEditDetails().then(()=>{
                        setActiveStep(2)
                    })
                }
            break;
            case 2: 
                setActiveStep(3)
            break;
            case 3: 
                if(examData.modules?.length === 1)
                    handlePubblishExam()
                else
                    setActiveStep(4)
            break;
            case 4: 
                handlePubblishExam()
            break;
            case 5: 
                handlePubblishExam()
            break;
        }
    }

    const checkDisabled = () => {
        switch(activeStep){
            case 3: 
                if(examData.modules?.length === 0)
                    return true
            break;
            case 4: 
                if(examData.modules?.length === 0)
                    return true
            break;
            default:
                return false
        }
    }

    const loadExamData = async ( ) => {
        let _exam_id = examData.exam_id || exam_id 
        const response =  await fetchExam(_exam_id)
        if(response.success){
            setExamData(response.data)
            dispatch(setLoading(false))
        } else {
            console.error("error")
        }
    }

    // copia in bozza di una verifica esistente: le domande restano riferimenti alla question bank,
    // la nuova verifica viene creata solo al primo salvataggio
    const loadDuplicateData = async () => {
        dispatch(setLoading(true))
        const response = await fetchExam(duplicateFrom)
        dispatch(setLoading(false))
        if(!response.success){
            toast.error(t.exam.error_saving_exam)
            return
        }
        const { exam_id: _, start_date, end_date, ...data } = response.data
        setExamData({
            ...data,
            title: `${data.title} ${t.exams.copy_suffix}`,
            state: 'draft'
        })
        setIsUpdated(true)
    }

    useEffect(()=>{
        if(!props.isNew){
            dispatch(setLoading(true))
            loadExamData()
        } else if(duplicateFrom){
            loadDuplicateData()
        } else {
            setExamData({
                allowed_all: true,
                state: "draft",
                time: ""
            })
        }
    },[])

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData  = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta, isOpen } = useTour()

    const restartTour = () => {
        if(userOnboarding?.exams?.section_completed){
            setIsOpen(true)
            setSteps(examsTourSteps(exam_id, setActiveStep))
            setCurrentStep(3)
            setMeta('exams')
        } else {
            setSteps(examsTourSteps(exam_id, setActiveStep))
            setCurrentStep(userOnboarding?.exams?.step_completed_count > 2 ? userOnboarding?.exams?.step_completed_count : 3)
            setMeta('exams')
            setTimeout(()=>{
                if(window.location.pathname?.includes("exams"))
                    setIsOpen(true)
            },2000)
            if(userOnboarding?.exams?.step_completed_count > 3){
                switch(userOnboarding?.exams?.step_completed_count){
                    case 4:{
                        setActiveStep(1)
                    }
                    break;
                    case 5:{
                        setActiveStep(2)
                    }
                    break;
                    case 6: {
                        setActiveStep(3)
                    }
                    break
                }
            }
        }
    }
    
    useEffect(()=>{
        setIsOpen(false)
        if(!userData?.is_super_admin){
            if(!userOnboarding?.exams?.section_completed && userOnboarding?.exams?.step_completed_count > 2){
                setTimeout(()=>setIsOpen(true),3000)
                setTimeout(()=>{
                    if(window.location.pathname?.includes("exams"))
                        setIsOpen(true)
                },2000)
                setSteps(examsTourSteps(exam_id, setActiveStep))
                setCurrentStep(userOnboarding?.exams?.step_completed_count)
                setMeta('exams')
                //Move to correct exam details step
                if(userOnboarding?.exams?.step_completed_count > 3){
                    switch(userOnboarding?.exams?.step_completed_count){
                        case 4:{
                            setActiveStep(1)
                        }
                        break;
                        case 5:{
                            setActiveStep(2)
                        }
                        break;
                        case 6: {
                            setActiveStep(3)
                        }
                        break
                    }
                }
            } else if(userOnboarding?.exams?.step_completed_count === 2 && !userOnboarding?.exams?.section_completed) {
                dispatch(
                    updateUserOnboarding({
                        onboarding_step: {
                            step_completed_count: 3,
                            section_completed: false,
                            section: 'exams'
                        }
                    })
                );
                setTimeout(()=>{
                    if(window.location.pathname?.includes("exams"))
                        setIsOpen(true)
                },2000)
                setSteps(examsTourSteps(exam_id, setActiveStep))
                setCurrentStep(3)
                setMeta('exams')
            }
        }
        
    },[])

    return (
        <section>
            
            {
                !isOpen &&
                <div className='demo-activator fixed' onClick={restartTour}>
                    <img src={question_img} />
                </div>
            }
            <Stepper 
                activeStep={activeStep}
                styleConfig={{
                    activeBgColor: "#436094",
                    completedBgColor: "#436094",
                    inactiveBgColor: "#E2E2E2"
                }}
                nonLinear={!props.isNew}
            >
                <Step label={t.exam.info}  onClick={()=>setActiveStep(0)}/>
                <Step label={t.exam.users} onClick={()=>setActiveStep(1)}/>
                <Step label={t.exam.questions} onClick={()=>setActiveStep(2)}/>
                <Step label={t.exam.structure} disabled={!examData?.modules || examData.modules?.length === 0} onClick={()=>setActiveStep(3)}/>
                {
                    examData.modules?.length > 1 ?
                        <Step label={t.exam.modules} disabled={!examData?.modules || examData.modules?.length === 0} onClick={()=>setActiveStep(4)}/>
                    : null
                }
                {
                    tenantSetting?.is_proctoring_available  ?
                        <Step label={'Proctoring'} onClick={()=>setActiveStep(5)}/>
                    : null
                }
                
            </Stepper>
            <div className='container'>
              {
                    examData ? 
                    <>
                        {
                            activeStep === 0 ?
                            <>
                                <ExamInfo examData={examData} onExamDataChange={handleExamDataChange} />
                            </>
                            : null
                        }
                        {
                            activeStep === 1 ?
                            <>
                                <ExamPermissions examData={examData} onExamDataChange={handleExamDataChange} />
                            </>
                            : null
                        }
                        {
                            activeStep === 2 ?
                            <>
                                <ExamQuestion examData={examData} onExamDataChange={handleExamDataChange} reloadData={loadExamData} onSuspendExam={handleSuspendExam} />
                            </>
                            : null
                        }
                        {
                            activeStep === 3 ?
                            <>
                                <ExamSettings examData={examData} onExamDataChange={handleExamDataChange} reloadData={loadExamData} onSuspendExam={handleSuspendExam} />
                            </>
                            : null
                        }
                        {
                            activeStep === 4 ?
                            <>
                                <ExamModules examData={examData} onExamDataChange={handleExamDataChange} reloadData={loadExamData} onSuspendExam={handleSuspendExam} />
                            </>
                            : null
                        }
                        {
                            activeStep === 5 ?
                            <>
                                <ExamProctoring examData={examData} onExamDataChange={handleExamDataChange} reloadData={loadExamData} />
                            </>
                            : null
                        }
                    </> : null
                }  
            </div>
            <footer className='control-footer'>
                <div className='d-flex align-items-center justify-content-between'>
                    <div> 
                        <Link to={'/exams'}>
                            <u>{t.buttons.exit_without_save}</u>
                        </Link>
                    </div>
                    <div className='d-flex justify-content-end exams-step-7'>
                        {
                            (examData?.state === "draft" || examData.state === "deleted") &&
                                <button disabled={!isUpdated} className='secondary' onClick={handleSaveDraft}>
                                    {t.buttons.save_draft}
                                </button>
                        }
                        {
                            (examData?.state === "ready" && activeStep < 2) &&
                                <button disabled={!isUpdated} className='secondary' onClick={handleEditDetails}>
                                    {t.buttons.edit_save}
                                </button>
                        }
                        <button disabled={!isUpdated || checkDisabled()} className='ms-2' onClick={handleNextStep}>
                            {renderButton()} <img src={arrow_img} alt='' /> 
                        </button>
                    </div>
                </div>
            </footer>
            <ConfirmModal props={confirmModal}/>
        </section>
    )
}